import React, { Component } from 'react';
import Ink from 'react-ink';

class ListingComponent extends Component {

    render () {

        const { listingData, imageSizeParams } = this.props;

        const listingImageStyle = listingData.file_name.length
            ? {backgroundImage: `url("${listingData.base_path}${listingData.file_name + imageSizeParams.walk}")`}
            : null;

        const listingPriceBlock = listingData.price
            ? <p className="listing-price">{listingData.price}</p>
            : null;

        const listingBedroomBlock = !!+listingData.bedrooms
            ? <span>{listingData.bedrooms} Bedroom</span>
            : null;

        const listingBathroomBlock = listingData.bathrooms
            ? <span>{listingData.bathrooms} Bathroom</span>
            : null;

        const listingFactsBlock = listingBedroomBlock && listingBathroomBlock
            ? (
                <div>
                    {listingBedroomBlock}, {listingBathroomBlock}
                </div>
            )
            : (
                <div>
                    {listingBedroomBlock}{listingBathroomBlock}
                </div>
            )

        const status = listingData.listing_status.toLowerCase();

        const listingStatusBlock = (['rented', 'sold', 'leased', 'off market', 'pending'].includes(status))
            ? (
                <div className="more-listing-status">{status}</div>
            )
            : null;

        return (
            <div className={`listing-component ${listingData.theme.toLowerCase()}`}>
                <div className="listing-content" style={listingImageStyle}>
                    {listingStatusBlock}
                    <div className="listing-overlay">
                        <div className="left-part">
                            <h3 className="listing-street">{listingData.street}</h3>
                            {listingPriceBlock}
                            <div className="listing-facts">
                                {listingFactsBlock}
                            </div>
                        </div>
                        <div className="right-part">
                            <a
                                href={listingData.tour_link}
                                target='_blank'
                                className="btn">
                                View Tour
                                <Ink />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ListingComponent;
